/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js';
import constants from '@/constants.js';

export default {

  //////////////////////////////
  /// Organization Specific
  //////////////////////////////

  async createOrganization({ commit }, organizationObj) {
    try {

      const payload = {
        userId: organizationObj.userId,
        name: organizationObj.name,
        website: organizationObj.website,
        logo: organizationObj.logo,
        olObj: organizationObj.olObj,
        workEmail: organizationObj.workEmail,
        organizationType: organizationObj.organizationType,
        location: organizationObj.location,
        primaryThemeColor: organizationObj.primaryThemeColor,
        secondaryThemeColor: organizationObj.secondaryThemeColor,
        organizationCulture: organizationObj.organizationCulture,
        about: organizationObj.about,
      };

      const resObj = await axios.post(`${constants.apiHost}/organization`, payload);
      commit('SET_ORGANIZATION', resObj.data);

      // log activity
      payload['organizationId'] = resObj.data._id;
      const logText = `Created a new Organization - ${payload.name}`;
      axios.post(`${constants.apiHost}/actvt-log`, {logText, ...payload});

      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchOrganization({ commit }, _id) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/organization/${_id}`);
      commit('SET_ORGANIZATION', resObj.data);
      // // console.log(resObj);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchOrganizationById({ commit }, _id) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/organization/${_id}`);
      commit('SET_ORGANIZATION', resObj.data);
      // // console.log(resObj);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchOrganizationByUserId({ commit }, userId) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/organization`, { params: { userId } });
      commit('SET_ORGANIZATION', resObj.data.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchOrganizationBySlug({ commit }, slug) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/organization`, { params: { slug } });
      commit('SET_ORGANIZATION', resObj.data.data[0]);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async checkSlug({ commit }, slug) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/organization`, { params: { slug } });
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async updateOrganization({ commit }, organizationObj) {
    try {
      const _id = organizationObj._id;
      const orgPayload = {
        name: organizationObj.name,
        website: organizationObj.website,
        logo: organizationObj.logo,
        olObj: organizationObj.olObj,
        workEmail: organizationObj.workEmail,
        slug: organizationObj.slug,
        organizationType: organizationObj.organizationType,
        location: organizationObj.location,
        primaryThemeColor: organizationObj.primaryThemeColor,
        secondaryThemeColor: organizationObj.secondaryThemeColor,
        organizationCulture: organizationObj.organizationCulture,
        about: organizationObj.about,
      };
      const resObj = await axios.patch(`${constants.apiHost}/organization/${_id}`, orgPayload);
      commit('SET_ORGANIZATION', resObj.data);

      // log activity
      orgPayload['organizationId'] = resObj.data._id;
      const logText = `Updated Organization Details - ${orgPayload.name}`;
      axios.post(`${constants.apiHost}/actvt-log`, {logText, ...orgPayload});

      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async inviteOrganizationAdmin({ commit }, adminInviteObj) {
    try {
      const payload = {
        email: adminInviteObj.email,
        status: adminInviteObj.status,
        organizationId: adminInviteObj.organizationId,
        maxRole: adminInviteObj.maxRole,
      };
      const resObj = await axios.post(`${constants.apiHost}/organization-subadmins`, payload);
      commit('SET_ORGANIZATION_SUBADMIN', resObj.data);

      // send sub-admin invite email
      const mailPayload = {
        mailType: 'organization-sub-admin-invitation',
        organizationName: adminInviteObj.organizationName,
        email: adminInviteObj.email,
      };
      // async
      axios.post(`${constants.apiHost}/mailer`, mailPayload);

      // log activity
      payload['organizationId'] = adminInviteObj.organizationId;
      const logText = `Added a new Sub-Admin - ${payload.email}`;
      axios.post(`${constants.apiHost}/actvt-log`, {logText, ...payload});

      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async revokeSubAdmin({ commit }, { orgSubAdminId, subAdminEmail, organizationId }) {
    try {
      const resObj = await axios.delete(`${constants.apiHost}/organization-subadmins/${orgSubAdminId}`);
      commit('REMOVE_ORGANIZATION_SUBADMIN', orgSubAdminId);

      // log activity
      const logPayload = {};
      logPayload['organizationId'] = organizationId;
      const logText = `Removed a Sub-Admin - ${subAdminEmail}`;
      axios.post(`${constants.apiHost}/actvt-log`, {logText, ...logPayload});

      return resObj;
    } catch (error) {
      throw error;
    }

  },
  async fetchOrganizationAdminByEmail({ commit }, adminObj) {
    try {
      const params = {
        email: adminObj.email,
        organizationId: adminObj.organizationId
      };

      const resObj = await axios.get(`${constants.apiHost}/organization-subadmins`, { params });

      // fetch organization sub-admins
      const organizationId = params.organizationId;
      const orgResObj = await axios.get(`${constants.apiHost}/organization/${organizationId}`);
      resObj.data['organization'] = orgResObj.data;

      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchSubAdminByEmailOrgId({ commit }, orgObj) {
    try {
      const email = orgObj.email;
      const organizationId = orgObj.organizationId;
      const resObj = await axios.get(`${constants.apiHost}/organization-subadmins`, { params: { email, organizationId } });
      return resObj;
    }
    catch {
      throw error;
    }
  },
  async checkAlexAdminByEmail({ commit }, adminObj) {
    try {

      const params = {
        email: adminObj.email
      };

      const resObj = await axios.get(`${constants.apiHost}/organization-subadmins`, { params });
      // fetch organization sub-admins
      // // console.log(resObj.data);
      return resObj.data;

    } catch (error) {
      throw error;
    }
  },
  async fetchAllMyOrganizations({ commit }, orgObj) {
    try {
      const email = orgObj.email;
      const userId = orgObj.userId;
      const subResObj = await axios.get(`${constants.apiHost}/organization-subadmins`, { params: { email } });
      const superResObj = await axios.get(`${constants.apiHost}/organization`, { params: { userId } });
      const allOrgs = { superOrgs: superResObj.data.data, subOrgs: subResObj.data.data };
      // // console.log(allOrgs);
      commit('SET_MY_ORGANIZATIONS', allOrgs);
      return allOrgs;
    } catch (error) {
      throw error;
    }
  },
  async onlyFetchAllMyOrganizations({ commit }, orgObj) {
    try {
      const email = orgObj.email;
      const userId = orgObj.userId;
      const subResObj = await axios.get(`${constants.apiHost}/organization-subadmins`, { params: { email } });
      const superResObj = await axios.get(`${constants.apiHost}/organization`, { params: { userId } });
      const allOrgs = { superOrgs: superResObj.data.data, subOrgs: subResObj.data.data };
      // // console.log(allOrgs);
      // commit('SET_MY_ORGANIZATIONS', allOrgs);
      return allOrgs;
    } catch (error) {
      throw error;
    }
  },
  async acceptAdminOrgInvite({ commit }, adminObj) {
    try {
      const adminId = adminObj.adminId;
      const status = 'active';
      const resObj = await axios.patch(`${constants.apiHost}/organization-subadmins/${adminId}`, { status });
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchOrgActivityLogData({ commit }, { organizationId }) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/actvt-log`, { params: { organizationId } });
      return resObj.data.data;
    } catch (error) {
      throw error;
    }
  },
  async logOrganizationActivity({ commit }, { logObj, organizationId }) {
    try {
      let payload = logObj;
      // log activity
      payload['organizationId'] = organizationId;
      if(payload.logText && payload['organizationId']) {
        axios.post(`${constants.apiHost}/actvt-log`, payload);
      }
    } catch (err) {
      throw err;
    }
  },
  async fetchAllRktSubscriptions({ commit }, { subsObj, orgSlug }) {
    try {
      if(orgSlug) {
        const subscriptions = await axios.get(`${constants.commServiceUrl}/rkt/${orgSlug}/subscriptions/${subsObj.userId}`);
        return subscriptions.data.data;
      }
    } catch (err) {
      throw err;
    }
  },
  async checkCommServerStatus({ commit }, { orgSlug }) {
    try {
      if(orgSlug) {
        const commSetup = await axios.get(`${constants.commServiceUrl}/rkt/${orgSlug}/setup`);
        return commSetup.data;
      }
    } catch (err) {
      throw err;
    }
  },
  async saveCoachConfig({ commit }, coachConfigDetails) {
    try {
      const organizationId = coachConfigDetails.organizationId;
      const resObj = await axios.patch(`${constants.apiHost}/organization/${organizationId}`, coachConfigDetails);
      commit('SAVE_COACH_CONFIGS', coachConfigDetails['appConfigs.coach'] || coachConfigDetails['appConfigs']['coach'])
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveHibobConfig({ commit }, hibobConfigDetails) {
    try {
      const organizationId = hibobConfigDetails.organizationId;
      const resObj = await axios.patch(`${constants.apiHost}/organization/${organizationId}`, hibobConfigDetails);
      commit('SAVE_HIBOB_CONFIGS', hibobConfigDetails['appConfigs.hibob'] || hibobConfigDetails['appConfigs']['hibob'])
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  /////////////////////////////
  // Organization API Keys
  /////////////////////////////
  async fetchAllAPIKeys({ commit }, { organizationId }) {
    try {
      if(organizationId) {
        const apiKeys = await axios.get(`${constants.connServiceUrl}/client/${organizationId}`);
        return apiKeys.data.data;
      }
      return [];
    } catch (err) {
      throw err;
    }
  },
  async issueAPIKey({ commit }, { organizationId, label, userId }) {
    try {
      if(organizationId && label && userId) {
        const apiKey = await axios.post(`${constants.connServiceUrl}/client/issue-key`, {
          organizationId,
          label,
          userId
        });
        return apiKey.data.data;
      }
    } catch (err) {
      throw err;
    }
  },
  async revokeAPIKey({ commit }, { apiKeyId }) {
    try {
      if(apiKeyId) {
        const apiKeys = await axios.delete(`${constants.connServiceUrl}/client/revoke/${apiKeyId}`);
        return apiKeys.data.data;
      }
    } catch (err) {
      throw err;
    }
  },
  

  /////////////////////////////
  // Organization Funds
  /////////////////////////////
  async fetchAllTransactions({ commit }, { organizationId }) {
    try {
      if(organizationId) {
        const transactions = await axios.get(`${constants.apiHost}/organization-funds`, { params: { organizationId } });
        return transactions.data.data;
      }
      return [];
    } catch (err) {
      throw err;
    }
  },
  async addFunds({ commit }, { organizationId, userId, amount, currency, referenceId, fundType }) {
    try {
      if(organizationId && userId && amount && currency && referenceId && fundType) {
        const transaction = await axios.post(`${constants.apiHost}/organization-funds`, {
          organizationId,
          userId,
          amount,
          currency,
          referenceId,
          fundType
        });
        return transaction.data.data;
      }
      throw 'Incomplete Info';
    } catch (err) {
      throw err;
    }
  },

  /////////////////////////////
  // Organization Employees
  /////////////////////////////
  async fetchAllEmployees({ commit }, { organizationId }) {
    try {
      if(organizationId) {
        const employees = await axios.get(`${constants.platformServiceUrl}/employees/${organizationId}`);
        commit('SAVE_EMPLOYEES', employees.data);
        return employees.data;
      }
      return [];
    } catch (err) {
      throw err;
    }
  },
  async deactivateEmployee({ commit }, employeeId) {
    try {
      if(employeeId) {
        const employees = await axios.patch(`${constants.platformServiceUrl}/employee/${employeeId}`, {
          "status": "deactivated"
        });
        commit('SAVE_EMPLOYEES', employees.data);
        return employees.data;
      }
      return [];
    } catch (err) {
      throw err;
    }
  },
}
